import clsx from "clsx";
import { AutoPlayVideo } from "@/src/components/AutoPlayVideo";
import { ProductCardThumbnailProps } from "..";
import { LoadingBarPulse } from "@/src/components/LoadingBarPulse";
import { useVideoStateController } from "../hooks";

function labelVideo(tokenName?: string | null) {
  if (tokenName) return `Video of ${tokenName}`;
  return "Video of product";
}

type ProductCardVideoProps = Pick<
  ProductCardThumbnailProps,
  "videoSrc" | "videoDescription" | "isHovered"
>;

export function ProductCardVideo(props: ProductCardVideoProps) {
  const videoController = useVideoStateController();

  return props.isHovered ? (
    <div className="hidden md:block">
      <AutoPlayVideo
        loop={false}
        src={props.videoSrc}
        aria-label={labelVideo(props.videoDescription)}
        className={clsx(
          "absolute inset-0 object-contain opacity-0 transition-opacity duration-300",
          {
            "opacity-100": videoController.showVideo,
          },
        )}
        onCanPlay={() => videoController.setCanPlay(true)}
        onWaiting={() => videoController.setIsWaiting(true)}
        onPlaying={() => {
          videoController.setIsComplete(false);
          videoController.setIsWaiting(false);
        }}
        onEnded={() => videoController.setIsComplete(true)}
      />
      {videoController.showLoader && (
        <LoadingBarPulse
          aria-label="Product video loading..."
          className="absolute bottom-0 left-0 right-0"
        />
      )}
    </div>
  ) : null;
}
